// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Enums
import {
  webPages,
  webSections,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Components
import Section from '../../../layout/Section';
import RegionsList from '../../../common/RegionsList';

// Types
import type {
  $ReducerState,
} from '../../../../redux';
import type {
  $RedirectAction,
  $SetRegionAction,
} from '../../../../redux/modules/main/actions';

export type $OwnProps = $Translate;

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = {
  redirect: $RedirectAction;
  setRegion: $SetRegionAction;
};

type $Props = $DispatchProps & $OwnProps & $StateProps;

const ListSectionView = function ({
  main,
  redirect,
  setRegion,
  t,
}: $Props) {
  return (main.regions.length > 0 ? (
    <Section
      id={webSections[webPages.regionsPage].list}
      title={t('Regions')}
    >
      <div className={'max-h-96 overflow-y-auto -mx-5 px-5 py-1'}>
        <RegionsList
          activeItemId={main.RegionId}
          data={main.regions}
          setItem={async ({
            RegionId,
          }) => {
            await setRegion({
              RegionId,
            });

            redirect({
              pathname: '/',
            });
          }}
        />
      </div>
    </Section>
  ) : (
    <Section
      id={'error'}
      title={t('Error')}
    >
      <>
        <div className={'mb-5'}>
          {t('Oops, an error occurred! Maybe try:')}
        </div>
        <div className={'text-center'}>
          <button
            className={'btn btn_secondary btn_outlined uppercase py-1 mb-3'}
            onClick={() => {
              if (window) {
                window.location.reload();
              }
            }}
            type={'button'}
          >
            {t('Refresh page')}
          </button>
          <div>
            <small>
              {t('If that does not help please ')}
              <a
                className={'text-blue-400'}
                href={'mailto:Regattas.eu<info@regattas.eu>?subject=Error on the regattas.eu'}
              >
                {t('Contact')}
              </a>
            </small>
          </div>
        </div>
      </>
    </Section>
  ));
};

export default ListSectionView;
